<!-- TEMPLATE: Box Component-->

<!-- Add Class by Boxtype (Modules, MyProgram, Exercises)-->
<div
  class="b2a-box"
  [ngClass]="{
    'up-box': boxType === up,
    'mp-box': boxType === mp,
    'ex-box': boxType === ex,
    'add-box': boxType === new,
    'challenge-box': boxType === 'challenge',
    'show-border': showBorder,
    selected: selected
  }"
  tabindex="0"
  (clickOutside)="closeAskRemove()"
>
  <div class="mp-box_numOfExercises" *ngIf="boxType === mp">
    <img src="assets/icons/myprograms/24x24/numExercise.png" onerror="this.style.display='none'" alt="{{ title }}"/>
    <div class="mp-box_numOfExercises_num">{{ num }}</div>
  </div>
  <div *ngIf="boxType !== 'challenge'" class="preview" (click)="clickOnActionbutton()">
    <img class="preview__image" src="{{ preview }}" onerror="this.style.display='none'" alt="{{ title }}"/>
    <!-- Hover State: Can be clicked to do action
    shows transparent Overlay & Actionicons (play, add) -->
    <div class="preview__overlay">
      <div class="actionIcon">
        <button mat-fab color="primary" *ngIf="type === play" title="Play">
          <div class="actionIcon__play"></div>
        </button>
        <button mat-fab *ngIf="type === add" class="add">
          <div class="actionIcon__add">+</div>
        </button>
        <button mat-fab *ngIf="type === remove">
          <div class="actionIcon__remove">-</div>
        </button>
      </div>
      <p class="duration" *ngIf="videoDuration != undefined && boxType === ex">{{videoDuration | duration}}</p>
    </div>
  </div>

  <div *ngIf="boxType === 'challenge'" class="preview">
    <img class="preview__image" src="{{ preview }}" onerror="this.style.display='none'" alt="{{ title }}"/>
    <!-- Hover State: Can be clicked to do action
    shows transparent Overlay & Actionicons (play, add) -->
    <div class="preview__overlay">
      <ng-container *ngIf="challengeStatus === ChallengeStatus.FUTURE">
        <p
          *ngIf="challenge?.minimalTeamMembers && team && team.userGroups.members.length < challenge?.minimalTeamMembers"
          class="team-info-memberlimit-not-reached"
        >
          {{ 'DASHBOARD.challenge.minimumTeamMembers' | translate: { members: challenge.minimalTeamMembers } }}
        </p>

        <ng-container *ngIf="!teamUser || teamUser?.membershipStatus === TeamMembershipStatus.NONE">
          <app-button
            class="button"
            type="primary"
            [label]="'DASHBOARD.challenge.actions.joinChallenge' | translate"
            (click)="navigateSelectTeam()"
          >
          </app-button>
        </ng-container>

        <ng-container *ngIf="teamUser?.membershipStatus === TeamMembershipStatus.APPLICATION">
          <div class="team-info">
            <p class="team-info-label">{{ 'DASHBOARD.challenge.teamLabelApplication' | translate }}</p>
            <p class="team-info-name">{{ team.name }}</p>
          </div>

          <app-button
            class="button"
            type="primary"
            [label]="'DASHBOARD.challenge.actions.showTeam' | translate"
            (click)="navigateTeamDetails()"
          >
          </app-button>

          <app-button
            class="button"
            type="error-transparent"
            [label]="'DASHBOARD.challenge.actions.cancelApplication' | translate"
            (click)="cancelApplication()"
          >
          </app-button>
        </ng-container>

        <ng-container *ngIf="teamUser?.membershipStatus === TeamMembershipStatus.INVITATION">
          <div class="team-info">
            <p class="team-info-label">{{ 'DASHBOARD.challenge.teamLabelInvitation' | translate }}</p>
            <p class="team-info-name">{{ team.name }}</p>
          </div>

          <app-button
            class="button"
            type="primary"
            [label]="'DASHBOARD.challenge.actions.selectTeam' | translate"
            (click)="navigateSelectTeam()"
          >
          </app-button>

          <app-button
            class="button"
            type="primary"
            [label]="'DASHBOARD.challenge.actions.acceptInvitation' | translate"
            (click)="acceptInvitation()"
          >
          </app-button>

          <app-button
            class="button"
            type="error-transparent"
            [label]="'DASHBOARD.challenge.actions.cancelInvitation' | translate"
            (click)="declineInvitation()"
          >
          </app-button>
        </ng-container>

        <ng-container *ngIf="teamUser && !teamUser.isFounder && teamUser.membershipStatus === TeamMembershipStatus.MEMBER">
          <ng-container *ngIf="!showLeaveTeamDialog">
            <div class="team-info">
              <p class="team-info-label">{{ 'DASHBOARD.challenge.teamLabelYourTeam' | translate }}</p>
              <p class="team-info-name">{{ team.name }}</p>
            </div>

            <app-button
              class="button"
              type="primary"
              [label]="'DASHBOARD.challenge.actions.showTeam' | translate"
              (click)="navigateTeamDetails()"
            >
            </app-button>

            <app-button
              class="button"
              type="error-transparent"
              [label]="'DASHBOARD.challenge.actions.leaveTeam' | translate"
              (click)="showLeaveTeam(true)"
            >
            </app-button>
          </ng-container>
          <ng-container *ngIf="showLeaveTeamDialog">
            <div class="team-info">{{ 'DASHBOARD.challenge.confirmLeaveTeam' | translate }}</div>

            <app-button
              class="button"
              type="primary"
              [label]="'DASHBOARD.challenge.actions.cancel' | translate"
              (click)="showLeaveTeam(false)"
            >
            </app-button>

            <app-button
              class="button"
              type="error-transparent"
              [label]="'DASHBOARD.challenge.actions.leaveTeam' | translate"
              (click)="confirmLeaveTeam()"
            >
            </app-button>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="teamUser?.isFounder && teamUser.membershipStatus === TeamMembershipStatus.MEMBER">
          <div class="team-info">
            <p class="team-info-label">{{ 'DASHBOARD.challenge.teamLabelYourTeam' | translate }}</p>
            <p class="team-info-name">{{ team.name }}</p>
          </div>

          <app-button
            class="button"
            type="primary"
            [label]="'DASHBOARD.challenge.actions.manageTeam' | translate"
            (click)="navigateTeamDetails()"
          >
          </app-button>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="challengeStatus === ChallengeStatus.RUNNING">
        <p
          *ngIf="challenge?.minimalTeamMembers && team && team.userGroups.members.length < challenge?.minimalTeamMembers"
          class="team-info-memberlimit-not-reached"
        >
          {{ 'DASHBOARD.challenge.minimumTeamMembers' | translate: { members: challenge.minimalTeamMembers } }}
        </p>

        <ng-container
          *ngIf="
            teamUser?.membershipStatus !== TeamMembershipStatus.MEMBER ||
            (challenge?.minimalTeamMembers && team && team.userGroups.members.length < challenge?.minimalTeamMembers)
          "
        >
          <div *ngIf="team" class="team-info">
            <p class="team-info-error">{{ 'DASHBOARD.challenge.participationState.membershipFailed' | translate }}</p>
          </div>

          <app-button
            class="button"
            type="primary"
            [label]="'DASHBOARD.challenge.actions.viewStatistics' | translate"
            (click)="navigateTeamDetails()"
          >
          </app-button>
        </ng-container>

        <ng-container
          *ngIf="
            teamUser?.membershipStatus === TeamMembershipStatus.MEMBER &&
            (!challenge?.minimalTeamMembers || (team && team.userGroups.members.length >= challenge?.minimalTeamMembers))
          "
        >
          <div *ngIf="team" class="team-info">
            <p class="team-info-label">{{ 'DASHBOARD.challenge.teamLabelYourTeam' | translate }}</p>
            <p class="team-info-name">{{ team.name }}</p>
          </div>

          <app-button
            class="button"
            type="primary"
            [label]="'DASHBOARD.challenge.actions.viewStatistics' | translate"
            (click)="navigateTeamDetails()"
          >
          </app-button>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- Customizing Infopanel of BoxTypes: Modules(up), MyProgram(mp), Exercises(ex) -->
  <div class="b2a-box__inner">
    <div class="title">
      {{ title }}
    </div>

    <div *ngIf="boxType === 'challenge' && challenge" class="info__container">
      <div class="info__days-container">
        <p class="info__days-label">
          <span *ngIf="challengeStatus === ChallengeStatus.FUTURE">{{ 'DASHBOARD.challenge.start' | translate }} </span
          ><span *ngIf="challengeStatus === ChallengeStatus.RUNNING">{{ 'DASHBOARD.challenge.end' | translate }} </span>
        </p>
        <span class="info__days"> {{ displayedTimeframe }} </span>
      </div>

      <button
        *ngIf="boxType === 'challenge'"
        class="info__button"
        (click)="openChallengeTutorial()"
        type="button"
        color="primary"
        mat-raised-button
      >
        {{ 'DASHBOARD.challenge.infoButton' | translate }}
      </button>

      <div class="info__status-container">
        <p class="info__status-label">{{ 'DASHBOARD.challenge.participationState.label' | translate }}</p>

        <span
          *ngIf="challengeStatus === ChallengeStatus.FUTURE"
          class="info__status"
          [ngClass]="'info__status--' + teamUser?.membershipStatus"
          >{{
            'DASHBOARD.challenge.participationState.' + (teamUser ? (teamUser?.isFounder ? 'founder' : teamUser?.membershipStatus) : 'none')
              | translate
          }}</span
        >

        <span
          *ngIf="
            challengeStatus !== ChallengeStatus.FUTURE &&
            teamUser?.membershipStatus === TeamMembershipStatus.MEMBER &&
            (!challenge?.minimalTeamMembers || (team && team.userGroups.members.length >= challenge?.minimalTeamMembers))
          "
          class="info__status info__status--member"
          >{{ 'DASHBOARD.challenge.participationState.' + (teamUser?.isFounder ? 'founder' : 'member') | translate }}</span
        >

        <!-- If challenge is already running or over, pending applications or invitations become invalid -->
        <span
          *ngIf="
            challengeStatus !== ChallengeStatus.FUTURE &&
            (teamUser?.membershipStatus !== TeamMembershipStatus.MEMBER ||
              (challenge?.minimalTeamMembers && team && team.userGroups.members.length < challenge?.minimalTeamMembers))
          "
          class="info__status info__status--none"
          >{{ 'DASHBOARD.challenge.participationState.none' | translate }}</span
        >
      </div>
    </div>

    <div class="des" *ngIf="boxType === up">
      {{ description }}
    </div>

    <div class="categories" *ngIf="boxType === ex">
      <div class="categories__item" *ngFor="let cat of categories">{{ cat.title[translate.currentLang] }}</div>
    </div>

    <div class="icons" *ngIf="boxType === mp && !hideButtons">
      <div class="icons_iconItem" (click)="editBox()">
        <img src="assets/icons/myprograms/24x24/edit.png" onerror="this.style.display='none'" alt="{{ 'EXERCISES.altEdit' | translate }}" />
      </div>
      <div class="icons_iconItem" (click)="removeAskBox()">
        <img
          src="assets/icons/myprograms/24x24/remove.png"
          onerror="this.style.display='none'"
          alt="{{ 'EXERCISES.altDelete' | translate }}"
        />
      </div>
    </div>
  </div>

  <!-- Delete Overlay-->
  <div class="delete-overlay" *ngIf="showDelete" [@openDelete]>
    <div [innerHTML]="'EXERCISES.deletePromptText' | translate: { title: title }"></div>
    <button color="warn" (click)="removeBox($event)" mat-raised-button>
      {{ 'EXERCISES.deletePromptBtn' | translate }}
    </button>
  </div>

  <video #myVideo controls style="display: none;">
    <source src={{videoUrl}} type="video/mp4">
  </video>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/box/box.component.html